import React, { useEffect, useState, useRef } from 'react';
import close_button from '../../../assets/close_button.png';
import ScmModuleStyle from '../styles/scm.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

const TotalUnitsGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, seriesStatus, setSeriesStatus }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "first": [], "second": [], "third": [], "fourth": [] });
  const [CostsData, setCostsData] = useState({ "first": [], "second": [], "third": [], "fourth": [] });
  const [quarterMax, setQuarterMax] = useState([])
  const [xAxisMinMax, setXAxisMinMax] = useState({ "first": { min: 1, max: quarterMax[0] }, "second": { min: 1, max: quarterMax[1] }, "third": { min: 1, max: quarterMax[2] }, "fourth": { min: 1, max: quarterMax[3] } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setTotalUnitsGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const prevDataRef = useRef();

  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  function formatNumberWithCommas(number) {
    //Added for tooltip formatter to 1,334
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  const countSaturdaysInQuarter = (quarter) => {
    // Define quarter start and end dates
    const year = simObj?.laststate?.stateyear//new Date().getFullYear(); 
    const quarters = {
      1: [new Date(year, 0, 1), new Date(year, 2, 31)],
      2: [new Date(year, 3, 1), new Date(year, 5, 30)],
      3: [new Date(year, 6, 1), new Date(year, 8, 30)],
      4: [new Date(year, 9, 1), new Date(year, 11, 31)]
    };

    const [startDate, endDate] = quarters[quarter];

    // Count Saturdays within the specified quarter
    let saturdayCount = 0;
    for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
      if (currentDate.getDay() === 6) { // Saturday has index 6
        saturdayCount++;
      }
    }

    return saturdayCount;
  }
  const setGraphData = () => {
    if (chart != undefined) {
      let firstQuarterReq1PerWeek = [];
      let firstQuarterReq2PerWeek = [];
      let secondQuarterReq1PerWeek = [];
      let secondQuarterReq2PerWeek = [];
      let thirdQuarterReq1PerWeek = [];
      let thirdQuarterReq2PerWeek = [];
      let fourthQuarterReq1PerWeek = [];
      let fourthQuarterReq2PerWeek = [];

      let monthDays = 0;
      let newPoint = "";
      let existingData = "";
      let newData = "";
      let date = new Date();
      chart?.yAxis != undefined && chart?.yAxis[0]?.update({ min: 0, max: undefined });

      switch (type) {
        case "first":
          firstQuarterReq1PerWeek = simObj?.graphdata;
          firstQuarterReq1PerWeek = firstQuarterReq1PerWeek?.filter(obj => { return obj?.qt === 1 });
          firstQuarterReq1PerWeek = (firstQuarterReq1PerWeek != undefined ? firstQuarterReq1PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              date: getDate(data.cd),
              requiredComponent1PerWeek: data.c1pw,
              supplierOrderDetailsComp1: data.so.Component1,
              pending: data?.pending
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            first: firstQuarterReq1PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            first: { min: 1, max: xAxisMinMax.first.max }
          }));
          //firstQuarterSKU1 series 0 for SKU1
          if (chart?.series != undefined && firstQuarterReq1PerWeek.length != chart?.series[0]?.data?.length) {
            let firstQuarterSKU1 = firstQuarterReq1PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp1
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            firstQuarterSKU1.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });
            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                color: {
                  pattern: {
                    path: 'M 0 10 L 10 0',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#407097' : '#005A70'
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            //setSeriesStatus([]); 
            setSeriesStatus(seriesData);
            chart?.series != undefined && chart?.series[0]?.setData(seriesData)
          }
          if (chart?.series != undefined && firstQuarterReq1PerWeek.length != chart?.series[1]?.data?.length) {

            let firstQl = [], totalWeek = xAxisMinMax.first.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (firstQuarterReq1PerWeek.length > 0) {
                if (i > firstQuarterReq1PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(firstQuarterReq1PerWeek[firstQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'y': Math.floor(firstQuarterReq1PerWeek[firstQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > firstQuarterReq1PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...firstQuarterReq1PerWeek, ...firstQl]);
          } else {
            let firstQl = [], totalWeek = xAxisMinMax.first.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (firstQuarterReq1PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                firstQl.push({
                  ...firstQuarterReq1PerWeek[0],
                  'requiredComponent1PerWeek': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'x': i
                })
              }
              else if (simObj?.graphdata) {
                if (i > firstQuarterReq1PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...firstQuarterReq1PerWeek, ...firstQl]);
          }

          //firstQuarterReq2PerWeek
          firstQuarterReq2PerWeek = simObj?.graphdata;
          firstQuarterReq2PerWeek = firstQuarterReq2PerWeek?.filter(obj => { return obj?.qt === 1 });
          firstQuarterReq2PerWeek = (firstQuarterReq2PerWeek != undefined ? firstQuarterReq2PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              date: getDate(data.cd),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
              pending: data?.pending
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            first: firstQuarterReq2PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            first: { min: 1, max: xAxisMinMax.first.max }
          }));
          //firstQuarterSKU2 series 2 for SKU2
          if (chart?.series != undefined && firstQuarterReq2PerWeek.length != chart?.series[2]?.data?.length) {
            let firstQuarterSKU2 = firstQuarterReq2PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp2
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            firstQuarterSKU2.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });
            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                color: {
                  pattern: {
                    path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#8c8c0f' : '#D46719',
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            chart?.series != undefined && chart?.series[2]?.setData(seriesData)
          }

          if (chart?.series != undefined && firstQuarterReq2PerWeek.length != chart?.series[3]?.data?.length) {

            let firstQl = [], totalWeek = xAxisMinMax.first.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (firstQuarterReq2PerWeek.length > 0) {
                if (i > firstQuarterReq2PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(firstQuarterReq2PerWeek[firstQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'y': Math.floor(firstQuarterReq2PerWeek[firstQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > firstQuarterReq2PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...firstQuarterReq2PerWeek, ...firstQl]);
          } else {
            let firstQl = [], totalWeek = xAxisMinMax.first.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (firstQuarterReq2PerWeek.length === 0 && simObj?.graphdata?.length == 0) {

                firstQl.push({
                  ...firstQuarterReq2PerWeek[0],
                  'requiredComponent2PerWeek': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'x': i
                })
              } else if (simObj?.graphdata) {
                if (i > firstQuarterReq2PerWeek.length) {
                  firstQl.push({
                    ...firstQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...firstQuarterReq2PerWeek, ...firstQl]);
          }
          break;

        case "second":
          //secondQuarterReq1PerWeek
          secondQuarterReq1PerWeek = simObj?.graphdata
          secondQuarterReq1PerWeek = secondQuarterReq1PerWeek?.filter(obj => obj?.qt === 2);
          secondQuarterReq1PerWeek = (secondQuarterReq1PerWeek != undefined ? secondQuarterReq1PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              date: getDate(data.cd),
              requiredComponent1PerWeek: data.c1pw,
              quarter: data?.qt,
              supplierOrderDetailsComp1: data.so.Component1,
              pending: data?.pending
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            second: secondQuarterReq1PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            second: { min: 1, max: xAxisMinMax.second.max }
          }));
          if (chart?.series != undefined && secondQuarterReq1PerWeek.length != chart?.series[0]?.data?.length) {
            let secondQuarterSKU1 = secondQuarterReq1PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp1
              }
            })

            let pRslt = [{ value: 0, status: 1 },];
            secondQuarterSKU1.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });
            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#407097' : '#005A70',
                color: {
                  pattern: {
                    path: 'M 0 10 L 10 0',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#407097' : '#005A70'
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });

            //setSeriesStatus([]); 
            setSeriesStatus(seriesData);
            chart?.series != undefined && chart?.series[0]?.setData(seriesData)
          }
          if (chart?.series != undefined && secondQuarterReq1PerWeek.length != chart?.series[1]?.data?.length) {

            let secondQl = [], totalWeek = xAxisMinMax.second.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (secondQuarterReq1PerWeek.length > 0) {
                if (i > secondQuarterReq1PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(secondQuarterReq1PerWeek[secondQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'y': Math.floor(secondQuarterReq1PerWeek[secondQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > secondQuarterReq1PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...secondQuarterReq1PerWeek, ...secondQl]);
          } else {
            let secondQl = [], totalWeek = xAxisMinMax.second.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (secondQuarterReq1PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                secondQl.push({
                  ...secondQuarterReq1PerWeek[0],
                  'requiredComponent1PerWeek': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'x': i
                })
              } else if (simObj?.graphdata) {
                if (i > secondQuarterReq1PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...secondQuarterReq1PerWeek, ...secondQl]);
          }

          //secondQuarterReq2PerWeek
          secondQuarterReq2PerWeek = simObj?.graphdata;
          secondQuarterReq2PerWeek = secondQuarterReq2PerWeek?.filter(obj => obj?.qt === 2);
          secondQuarterReq2PerWeek = (secondQuarterReq2PerWeek != undefined ? secondQuarterReq2PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              date: getDate(data.cd),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
              pending: data?.pending
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            second: secondQuarterReq2PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            second: { min: 1, max: xAxisMinMax.second.max }
          }));

          if (chart?.series != undefined && secondQuarterReq2PerWeek.length != chart?.series[2]?.data?.length) {
            let secondQuarterSKU2 = secondQuarterReq2PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp2
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            secondQuarterSKU2.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });
            const seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#8c8c0f' : '#D46719',
                color: {
                  pattern: {
                    path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#8c8c0f' : '#D46719',
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            chart?.series != undefined && chart?.series[2]?.setData(seriesData)
          }
          if (chart?.series != undefined && secondQuarterReq2PerWeek.length != chart?.series[3]?.data?.length) {

            let secondQl = [], totalWeek = xAxisMinMax.second.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (secondQuarterReq2PerWeek.length > 0) {
                if (i > secondQuarterReq2PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(secondQuarterReq2PerWeek[secondQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'y': Math.floor(secondQuarterReq2PerWeek[secondQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > secondQuarterReq2PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...secondQuarterReq2PerWeek, ...secondQl]);
          } else {
            let secondQl = [], totalWeek = xAxisMinMax.second.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (secondQuarterReq2PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                secondQl.push({
                  ...secondQuarterReq2PerWeek[0],
                  'requiredComponent2PerWeek': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'x': i
                })
              } else if (simObj?.graphdata) {
                if (i > secondQuarterReq2PerWeek.length) {
                  secondQl.push({
                    ...secondQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...secondQuarterReq2PerWeek, ...secondQl]);
          }
          break;

        case "third":
          //thirdQuarterReq1PerWeek
          thirdQuarterReq1PerWeek = simObj?.graphdata
          thirdQuarterReq1PerWeek = thirdQuarterReq1PerWeek?.filter(obj => obj?.qt === 3);
          thirdQuarterReq1PerWeek = (thirdQuarterReq1PerWeek != undefined ? thirdQuarterReq1PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              date: getDate(data.cd),
              requiredComponent1PerWeek: data.c1pw,
              quarter: data?.qt,
              supplierOrderDetailsComp1: data.so.Component1,
              pending: data?.pending
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            third: thirdQuarterReq1PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            third: { min: 1, max: xAxisMinMax.third.max }
          }));
          if (chart?.series != undefined && thirdQuarterReq1PerWeek.length != chart?.series[0]?.data?.length) {
            let thirdQuarterSKU1 = thirdQuarterReq1PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp1
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            thirdQuarterSKU1.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });

            let seriesData = pRslt.slice(0, 15).map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#407097' : '#005A70',
                color: {
                  pattern: {
                    path: 'M 0 10 L 10 0',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#407097' : '#005A70'
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            //setSeriesStatus([]); 
            setSeriesStatus(seriesData);
            chart?.series != undefined && chart?.series[0]?.setData(seriesData)
          }
          if (chart?.series != undefined && thirdQuarterReq1PerWeek.length != chart?.series[1]?.data?.length) {

            let thirdQl = [], totalWeek = xAxisMinMax.third.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (thirdQuarterReq1PerWeek.length > 0) {
                if (i > thirdQuarterReq1PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(thirdQuarterReq1PerWeek[thirdQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'y': Math.floor(thirdQuarterReq1PerWeek[thirdQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > thirdQuarterReq1PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...thirdQuarterReq1PerWeek, ...thirdQl]);
          } else {
            let thirdQl = [], totalWeek = xAxisMinMax.third.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (thirdQuarterReq1PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                thirdQl.push({
                  ...thirdQuarterReq1PerWeek[0],
                  'requiredComponent1PerWeek': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'x': i
                })
              }
              else if (simObj?.graphdata) {
                if (i > thirdQuarterReq1PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...thirdQuarterReq1PerWeek, ...thirdQl]);
          }

          //thirdQuarterReq2PerWeek
          thirdQuarterReq2PerWeek = simObj?.graphdata;
          thirdQuarterReq2PerWeek = thirdQuarterReq2PerWeek?.filter(obj => obj?.qt === 3);
          thirdQuarterReq2PerWeek = (thirdQuarterReq2PerWeek != undefined ? thirdQuarterReq2PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              date: getDate(data.cd),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
              pending: data?.pending
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            third: thirdQuarterReq2PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            third: { min: 1, max: xAxisMinMax.third.max }
          }));
          if (chart?.series != undefined && thirdQuarterReq2PerWeek.length != chart?.series[2]?.data?.length) {
            let thirdQuarterSKU2 = thirdQuarterReq2PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp2
              }
            })
            //Delivered SKU2
            let pRslt = [{ value: 0, status: 1 },];
            thirdQuarterSKU2.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });

            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#8c8c0f' : '#D46719',
                color: {
                  pattern: {
                    path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#8c8c0f' : '#D46719',
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            chart?.series != undefined && chart?.series[2]?.setData(seriesData)
          }
          if (chart?.series != undefined && thirdQuarterReq2PerWeek.length != chart?.series[3]?.data?.length) {
            let thirdQl = [], totalWeek = xAxisMinMax.third.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (thirdQuarterReq2PerWeek.length > 0) {
                if (i > thirdQuarterReq2PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(thirdQuarterReq2PerWeek[thirdQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'y': Math.floor(thirdQuarterReq2PerWeek[thirdQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > thirdQuarterReq2PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...thirdQuarterReq2PerWeek, ...thirdQl]);
          } else {
            let thirdQl = [], totalWeek = xAxisMinMax.third.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (thirdQuarterReq2PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                thirdQl.push({
                  ...thirdQuarterReq2PerWeek[0],
                  'requiredComponent2PerWeek': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'x': i
                })
              } else if (simObj?.graphdata) {
                if (i > thirdQuarterReq2PerWeek.length) {
                  thirdQl.push({
                    ...thirdQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...thirdQuarterReq2PerWeek, ...thirdQl]);
          }
          break;

        case "fourth":
          //fourthQuarterReq1PerWeek
          fourthQuarterReq1PerWeek = simObj?.graphdata
          fourthQuarterReq1PerWeek = fourthQuarterReq1PerWeek?.filter(obj => obj?.qt === 4);
          fourthQuarterReq1PerWeek = (fourthQuarterReq1PerWeek != undefined ? fourthQuarterReq1PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              date: getDate(data.cd),
              requiredComponent1PerWeek: data.c1pw,
              quarter: data?.qt,
              supplierOrderDetailsComp1: data.so.Component1,
              pending: data?.pending
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            fourth: fourthQuarterReq1PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            fourth: { min: 1, max: xAxisMinMax.fourth.max }
          }));

          if (chart?.series != undefined && fourthQuarterReq1PerWeek.length != chart?.series[0]?.data?.length) {
            let fourthQuarterSKU1 = fourthQuarterReq1PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp1
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            fourthQuarterSKU1.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });

            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#407097' : '#005A70',
                color: {
                  pattern: {
                    path: 'M 0 10 L 10 0',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#407097' : '#005A70'
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            //setSeriesStatus([]); 
            setSeriesStatus(seriesData);
            chart?.series != undefined && chart?.series[0]?.setData(seriesData)
          }
          if (chart?.series != undefined && fourthQuarterReq1PerWeek.length != chart?.series[1]?.data?.length) {
            let fourthQl = [], totalWeek = xAxisMinMax.fourth.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (fourthQuarterReq1PerWeek.length > 0) {
                if (i > fourthQuarterReq1PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(fourthQuarterReq1PerWeek[fourthQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'y': Math.floor(fourthQuarterReq1PerWeek[fourthQuarterReq1PerWeek?.length - 1]?.requiredComponent1PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > fourthQuarterReq1PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...fourthQuarterReq1PerWeek, ...fourthQl]);
          } else {
            let fourthQl = [], totalWeek = xAxisMinMax.fourth.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (fourthQuarterReq1PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                fourthQl.push({
                  ...fourthQuarterReq1PerWeek[0],
                  'requiredComponent1PerWeek': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent1PerWeek),
                  'x': i
                })
              }
              else if (simObj?.graphdata) {
                if (i > fourthQuarterReq1PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq1PerWeek[0],
                    'requiredComponent1PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c1pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[1]?.setData([...fourthQuarterReq1PerWeek, ...fourthQl]);
          }

          //fourthQuarterReq2PerWeek
          fourthQuarterReq2PerWeek = simObj?.graphdata;
          fourthQuarterReq2PerWeek = fourthQuarterReq2PerWeek?.filter(obj => obj?.qt === 4);
          fourthQuarterReq2PerWeek = (fourthQuarterReq2PerWeek != undefined ? fourthQuarterReq2PerWeek : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              date: getDate(data.cd),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
              pending: data?.pending
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            fourth: fourthQuarterReq2PerWeek
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            fourth: { min: 1, max: xAxisMinMax.fourth.max }
          }));
          if (chart?.series != undefined && fourthQuarterReq2PerWeek.length != chart?.series[2]?.data?.length) {
            let fourthQuarterSKU2 = fourthQuarterReq2PerWeek.map((item) => {
              return {
                "status": item.pending,
                "arr": item.supplierOrderDetailsComp2
              }
            })
            let pRslt = [{ value: 0, status: 1 },];
            fourthQuarterSKU2.forEach((pArrItemParent) => {
              let gStatus = pArrItemParent.status;
              if (pArrItemParent.arr.length !== 0) {
                let cRslt = [];
                pArrItemParent.arr.forEach((cArrItem) => {
                  if (cArrItem.pendingUnits !== undefined) {
                    // pendingUnits
                    cRslt.push({ 'value': Number(cArrItem.pendingUnits), 'status': gStatus });
                  } else {
                    // receivedOrdersUnits
                    cRslt.push({ 'value': Number(cArrItem.receivedOrdersUnits), 'status': gStatus });
                  }
                });
                // Now, cRslt contains an array of objects for a specific gStatus
                let cRsltArr = cRslt.map((item) => item.value);

                // Push the aggregated value for the current gStatus
                pRslt.push({ 'value': cRsltArr.reduce((acc, currval) => acc + currval, 0), 'status': gStatus });
              } else {
                // If pArrItemParent.arr is empty, push a default object
                pRslt.push({ 'value': 0, 'status': gStatus });
              }
            });
            let seriesData = pRslt.map((value, index) => {
              return {
                y: value.value,
                //color: value.status ? '#8c8c0f' : '#D46719',
                color: {
                  pattern: {
                    path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                    width: 10,
                    height: 10,
                    color: '#FFFFFF',
                    backgroundColor: value.status ? '#8c8c0f' : '#D46719',
          
                  }
                },
                [index]: value.status ? 'units pending' : 'units delivered'
              };
            });
            chart?.series != undefined && chart?.series[2]?.setData(seriesData)
          }
          if (chart?.series != undefined && fourthQuarterReq2PerWeek.length != chart?.series[3]?.data?.length) {

            let fourthQl = [], totalWeek = xAxisMinMax.fourth.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (fourthQuarterReq2PerWeek.length > 0) {
                if (i > fourthQuarterReq2PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(fourthQuarterReq2PerWeek[fourthQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'y': Math.floor(fourthQuarterReq2PerWeek[fourthQuarterReq2PerWeek?.length - 1]?.requiredComponent2PerWeek),
                    'x': i
                  })
                }
              } else if (simObj?.graphdata) {
                if (i > fourthQuarterReq2PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...fourthQuarterReq2PerWeek, ...fourthQl]);
          } else {
            let fourthQl = [], totalWeek = xAxisMinMax.fourth.max;
            for (let i = 1; i <= totalWeek; i++) {
              if (fourthQuarterReq2PerWeek.length === 0 && simObj?.graphdata?.length == 0) {
                fourthQl.push({
                  ...fourthQuarterReq2PerWeek[0],
                  'requiredComponent2PerWeek': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'y': Math.floor(simObj?.laststate?.requiredComponent2PerWeek),
                  'x': i
                })
              } else if (simObj?.graphdata) {
                if (i > fourthQuarterReq2PerWeek.length) {
                  fourthQl.push({
                    ...fourthQuarterReq2PerWeek[0],
                    'requiredComponent2PerWeek': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'y': Math.floor(simObj?.graphdata[simObj?.graphdata?.length - 1]?.c2pw),
                    'x': i
                  })
                }
              }
            }
            chart?.series != undefined && chart?.series[3]?.setData([...fourthQuarterReq2PerWeek, ...fourthQl]);
          }
          break;

        default:
          break;
      }
      // setDataLabel((simObj?.graphdata != undefined) ? simObj?.graphdata : []);
    }
  }

  function applyAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg.highcharts-root");
            if (svg) {
              setTimeout(() => {
              svg.setAttribute('role', 'img');

              svg.setAttribute('aria-label', 'Total number of units graph.');

              const oldDesc = svg.querySelector("desc");
              if (oldDesc) oldDesc.remove();

              const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
              desc.textContent = "This chart visualizes weekly deliveries of SKU1 and SKU2 alongside the required weekly delivery target. Columns represent units delivered, and dashed lines represent required targets.";
              svg.insertBefore(desc, svg.firstChild);
              },0);
            }
        }
  }

  //first Required weekly delivery
  //let firstQuarterReq1PerWeek = [80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80];
  //let secondQuarterReq1PerWeek = [11, 80, 35, 19, 65, 69, 14, 33, 77, 66, 85, 60, 30];
  //let thirdQuarterReq1PerWeek = [83, 68, 47, 98, 55, 88, 67, 95, 93, 85, 16, 34, 50, 40];
  //let fourthQuarterReq1PerWeek = [78, 93, 91, 53, 40, 57, 79, 50, 6, 49, 62, 10, 50];
  //second Required weekly delivery
  //let firstQuarterReq2PerWeek  = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 50];
  //let secondQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 40];
  //let thirdQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 20, 30];
  //let fourthQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 70];
  //SKU1
  //let firstQuarterSKU1 = ['',55, 12, 0, 0, 0, 0, 0, 0, 0, 86, 0, 1200]
  //let secondQuarterSKU1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]
  //let thirdQuarterSKU1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]
  //let fourthQuarterSKU1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]
  //SKU2
  //let firstQuarterSKU2 = [35, 31, 0, 0, 0, 0, 0, 0, 0, 68, 0, 0, 1100]
  //let secondQuarterSKU2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]
  //let thirdQuarterSKU2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]
  //let fourthQuarterSKU2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,0]

  var isMacbookSafari = function isMacbook() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("macintosh") && userAgent.includes("safari") && !userAgent.includes("chrome");
  }
  const xAxis = {
    "first": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      accessibility: {
        point: {

        }
      },
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    "second": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      // max:3,
      //tickmarkPlacement: 'on',
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      },
      accessibility: {
        point: {

        }
      }
    },
    "third": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      startOnTick: true,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      },
      accessibility: {
        point: {

        }
      },
    },
    "fourth": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      tickLength: 0,
      accessibility: {
        point: {

        }
      },
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }

    },
  }
  const yAxis = {
    "first": {
      //min: 0,
      // max: 10000000,
      // offset: -10,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      startOnTick: true,
      tickLength: 10,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      color: 'rgb(255,255,255)',
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }

      },

    },
    "second": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      tickLength: 10,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      color: 'rgb(255,255,255)',
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }
    },
    "third": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      startOnTick: true,
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }

    },
    "fourth": {
      //min: 0,
      // max: 10000000,
      // offset: -10,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      startOnTick: true,
      color: 'rgb(255,255,255)',
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }

      },

    },
  }
  graphSettings = {
    plotOptions: {
      column: {
        animation: false,
        groupPadding: 0
      },
      line: {
        animation: false
      },
      events: {
        legendItemClick: function () {
          return false; // Prevent default legend item click behavior
        }
      },
      series: {
        borderRadius: {
          radius: 0
        },
        stickyTracking: true,
        marker: {
          enabled: true,
        },
        states: {
          inactive: {
            enabled: false
          }
        }
      }
    },
    chart: {
      type: "line",
      responsive: false,
      //marginRight: 15,
      //marginLeft: 52,
      height: isMacbookSafari() ? 200 : 250,
      plotBorderWidth: 1,
      events: {
          render: function () {
              applyAccessibility(this);
          },
          redraw: function () {
              applyAccessibility(this);
          }
      }
    },
    title: null,
    legend: {
      enabled: false,
      align: 'left',
      verticalAlign: 'top',
      // floating: true,
      visible: true,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px'
      }
    },
    xAxis: xAxis[type],
    yAxis: yAxis[type],
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Week: ${point.x}; ${(point.series.name === "SKU1 ") ? `SKU1 ${point[point.x]}: ${Math.floor(point.y)};` : ``} ${(point.requiredComponent1PerWeek != undefined) ? `Required weekly delivery: ${Math.floor(point.requiredComponent1PerWeek)};` : ``} ${(point.series.name === "SKU2 ") ? `SKU2 ${point[point.x]}: ${Math.floor(point.y)};` : ``} ${(point.requiredComponent2PerWeek != undefined) ? `Required weekly delivery: ${Math.floor(point.requiredComponent2PerWeek)};` : ``}`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "SKU1 ",
        type: "column", // Set the chart type to column
        color: "#005A70", // Color for the first series
        data: type === "first" ? [] : type === "second" ? [] : type === "third" ? [] : type === "fourth" ? [] : "",
        groupPadding: 0, // Set groupPadding to 0 for grouped columns
        customSymbol: "●",
        zIndex: 2,
      },
      {
        name: "Required weekly delivery", //Blue line
        type: "line",
        lineWidth: 1,
        data: type === "first" ? [] : type === "second" ? [] : type === "third" ? [] : type === "fourth" ? [] : ``,
        dashStyle: "ShortDash",
        customSymbol: "--",
        color: "#005A70",
        marker: {
          enabled: false,
          fillColor: "transparent",
          radius: 2,
        },
        dataLabels: {
          enabled: false // Disable data labels for this series
        },
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
          hover: {
            halo: {
              size: 7,
              opacity: 0.5,
            },

          }
        },
        zIndex: 1,
      },
      {
        name: "SKU2 ",
        type: "column", // Set the chart type to column
        color: "#D46719", // Color for the second series
        data: type === "first" ? [] : type === "second" ? [] : type === "third" ? [] : type === "fourth" ? [] : "",
        groupPadding: 0, // Set groupPadding to 0 for grouped columns
        customSymbol: "●",
        zIndex: 2,
      },
      {
        name: "Required weekly delivery", //Orange line
        type: "line",
        lineWidth: 1,
        data: type === "first" ? [] : type === "second" ? [] : type === "third" ? [] : type === "fourth" ? [] : ``,
        dashStyle: "ShortDash",
        customSymbol: "--",
        color: "#D46719",

        marker: {
          enabled: false, // Enable markers only for "first" type
          fillColor: "transparent",
          radius: 2,
        },
        dataLabels: {
          enabled: false // Disable data labels for this series
        },
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
          hover: {
            halo: {
              size: 7,
              opacity: 0.5,
            },

          }
        },
        zIndex: 1,
      }
    ],
    tooltip: {
      borderWidth: 1,
      shared: true,
      useHTML: true,
      crosshairs: true,
      headerFormat: "<strong>Week: {point.key}</strong><table>",
      pointFormatter: function () { 
        if (this.series.name === "Required weekly delivery") {
          return '<tr><td style="color: ' + this.color + '"><span>' + this.series.options.customSymbol + '</span> ' + this.series.name + ': </td><td style="text-align: right"><strong>' + formatNumberWithCommas(this.y) + '</strong></td></tr>';
        }
        else if (prevDataRef.current.length != 0 && (this.series.name === "SKU1 " || this.series.name === "SKU2 ")) {
          return '<tr><td style="color: ' + this.color.pattern.backgroundColor + '"><span>' + this.series.options.customSymbol + '</span> ' + this.series.name + prevDataRef.current.filter((item) => item[this.x])[0][this.x] + ': </td><td style="text-align: right"><strong>' + formatNumberWithCommas(this.y) + '</strong></td></tr>';
        }
      },
      footerFormat: "</table>",
      backgroundColor: "#fff"
    }

  }

  useEffect(() => {
    // Save the current data to prevDataRef
    prevDataRef.current = seriesStatus;
  }, [seriesStatus]);

  useEffect(() => {
    const newChart = Highcharts.chart("Total-Units", graphSettings);
    setChart(newChart);
    /*if (type === "first" || type === "second" || type === "third" || type === "fourth") {
      const g_container = ScmModuleStyle['graph-container'];
      let gContainer = document.getElementsByClassName(`${g_container}`)[0];
      gContainer.setAttribute("tabindex", '-1');
      gContainer.focus();
    }*/
  }, [type]); //(JSON.stringify(prevDataRef.current) !== JSON.stringify(seriesStatus))

  useEffect(() => {
    if (simObj?.laststate?.stateyear !== undefined) {
      for (let quarter = 1; quarter <= 4; quarter++) {
        const saturdayCount = countSaturdaysInQuarter(quarter);
        setQuarterMax((prevData) => [...prevData, saturdayCount]);
      }
    }
  }, [simObj?.laststate?.stateyear]);

  useEffect(() => {
    setGraphData();
    if (chart != undefined) {
      setTotalUnitsGraphLabel(`SKU1, SKU2 and Required weekly delivery of units graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval}$ per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#Total-Units").setAttribute('role', `figure`);
      document.querySelector("#Total-Units .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata, simObj?.laststate]);

  useEffect(() => {
    document.getElementsByClassName(`quarter${simObj?.laststate?.quarter}`)[0]?.click();
  }, [simObj?.laststate?.quarter])
  
  useEffect(() => {
    for (let i = 0; i < quarterMax.length; i++) {
      setXAxisMinMax((prevData) => {
        return {
          ...prevData,
          [i === 0 ? 'first' : i === 1 ? 'second' : i === 2 ? 'third' : 'fourth']: {
            min: 1,
            max: quarterMax[i],
          },
        };
      });
    }
  }, [quarterMax, chart])

  // useEffect(()=>{
  //   console.log(xAxisMinMax)
  //  },[xAxisMinMax])
  return (
    <div className={`${ScmModuleStyle['graph-container']}`} >
      <a href="#" onClick={(e) => e.preventDefault()} aria-label="Legends: Bar with square for SKU1,SKU2 units and dashed line with Required weekly delivery" className="sr-only"></a>
      <div id="Total-Units" className={`${ScmModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default TotalUnitsGraph